<template>
  <div class="home-content-page-v">
    <div class="content-one">
      <content-title title="数据源"></content-title>
      <div class="output-content-1">
        <div class="checkbox-content">
          <span>数据导入</span>
          <a href="javascript:;" class="checkbox-one" @click="activeImportWayKey = wayData.key" v-for='wayData in importWays'>
            <img src="~assets/checked-2.png" alt="" v-if="wayData.key === activeImportWayKey">
            <img src="~assets/unchecked-2.png" alt="" v-else>
            <div class="checkbox-label">
              {{wayData.name}}
            </div>
            <input style="margin-left: 4rem;" v-if="wayData.key === 'local_file' && wayData.key === activeImportWayKey" type="file" @change="importf" id="file-1"/>
            <a v-if="wayData.key === 'local_file' && wayData.key === activeImportWayKey" href="/static/ele_demo.xlsx" class="output-btn-sm" download="演示数据">演示数据下载</a>
          </a>
          <a href="javascript:;" class="output-btn btm-btn" @click="goSourceDataPage">导入</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import ContentTitle from '../../components_bit/ContentTitle'
  import XLSX from 'xlsx'
  export default {
    components: {
      ContentTitle
    },
    methods: {
      importf (e) {
        this.localFile = null
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        if (['xlsx'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
          this.localFile = files[0]
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '系统提示',
            message: '请选择excel文件。'
          })
          document.getElementById('file-1').value = ''
        }
      },
      readData () {
        let vm = this
        let reader = new FileReader()
        reader.onload = function (e) {
          let allDatas = {}
          let data = e.target.result
          let wb = XLSX.read(data, {
            type: 'binary'
          })
          if (vm.testSheets(wb.SheetNames)) {
            vm.sheets.forEach(function (item) {
              let newDatas = []
              if (item.name === '负荷数据') {
                let datas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
                datas.forEach(function (item) {
                  newDatas.push([item['时间'], Number(item['工作日'])])
                })
              } else if (item.name === '光伏出力') {
                let datas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
                datas.forEach(function (item) {
                  newDatas.push(['sun', item['时间'], Number(item['阴雨天']), Number(item['晴天'])])
                })
              } else if (item.name === '电价') {
                let datas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
                datas.forEach(function (item) {
                  newDatas.push(['master', item['时间'], Number(item['网购电价']), Number(item['余量上网电价'])])
                })
              } else if (item.name === '固定储能（通用储能特性）') {
                let datas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
                datas.forEach(function (item) {
                  newDatas.push([item['电量'], Number(item['功率下限']), Number(item['功率上限'])])
                })
              } else if (item.name === '移动储能') {
                let datas = XLSX.utils.sheet_to_row_object_array(wb.Sheets[item.name])
                let timeDatas = []
                datas.forEach(function (item) {
                  newDatas.push([item['时间'], Number(item['在网车辆数目']), Number(item['新增初始能量']), Number(item['储能下限']), Number(item['储能上限'])])
                  timeDatas.push(item['时间'])
                })
                allDatas['period'] = timeDatas
              }
              allDatas[item.key] = newDatas
            })
            allDatas['generator'] = [['wind', 'wind'], ['sun', 'sun'], ['battery', 'battery'], ['thermal', 'thermal'], ['master', 'master']]
            vm.$store.dispatch('setSourceDataEle', allDatas)
            vm.$router.push({'name': 'ele_source_data'})
          } else {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '系统提示',
              message: '导入数据格式不规范！'
            })
            document.getElementById('file-1').value = ''
          }
        }
        reader.readAsBinaryString(this.localFile)
      },
      goSourceDataPage () {
        if (this.activeImportWayKey === 'demo') {
          this.$store.dispatch('loadSourceDataEle')
          this.$router.push({'name': 'ele_source_data'})
        } else if (this.localFile) {
          this.readData()
        }
      },
      testSheets (data) {
        let ok = true
        this.sheets.forEach(function (item) {
          if (data.indexOf(item.name) === -1) {
            ok = false
          }
        })
        return ok
      }
    },
    computed: {
      caseList: {
        get () {
          return this.$store.getters.caseList
        }
      },
      activeCase: {
        get () {
          return this.$store.getters.activeCase
        }
      }
    },
    data () {
      return {
        localFile: null,
        dialogVisible: false,
        sheets: [{
          name: '负荷数据',
          key: 'load'
        },
        {
          name: '光伏出力',
          key: 'new_eng'
        },
        {
          name: '电价',
          key: 'grid_price'
        },
        {
          name: '固定储能（通用储能特性）',
          key: 'Steady_battery'
        },
        {
          name: '移动储能',
          key: 'Move_battery'
        }],
        activeImportWayKey: '',
        importWays: [{
          name: '本地文件',
          key: 'local_file'
        },
        {
          name: 'DEMO',
          key: 'demo'
        }]
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .content-one {
    background-color: #fff;
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-bottom: 2em;
  }
  .output-btn {
    align-self: flex-start;
    color:#fff;
    background-color: @bak-color-2;
    padding: 0.5em 1.5em;
    text-align: center;
    border-radius: 0.3em;
    letter-spacing: 0.1em;
  }
  .output-btn-sm {
    align-self: center;
    color:#fff;
    background-color: @bak-color-2;
    padding: 0.2rem 1rem;
    text-align: center;
    border-radius: 0.2rem;
    font-size: 0.8rem;
  }
  .output-content {
    flex:1;
    .content-shadow;
    .content-bottom-radius;
    display: flex;
    padding: 2em;
    min-height: 22em;
    background-color: #fff;
  }
  .btm-btn {
    margin: 1em 0 0 0em;
  }
  .m-line {
    width: 2px;
    background-color: #ccc;
    margin: 1.5em 2.2em 1.5em 0;
  }
  .output-content-1 {
    flex: 1;
    margin: 1em 2.5em 1em;
    display: flex;

  }
  .checkbox-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 1.13em;
      padding-bottom: 0.5em;
      color: @bak-color-2;
    }
    .app-note {
      padding: 2em 0 0 2em;
      font-size: 2em;
      color: #999;
    }
  }

  .checkbox-one {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    height: 3.4em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding-right: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// ele_import.vue?84c7767c